export default "<ion-app>\n  <ion-router-outlet></ion-router-outlet>\n  <app-course-detail></app-course-detail>\n</ion-app>\n";